// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3wAV0","card":"Card_card__3ohV0","front":"Card_front__3Gs6P","back":"Card_back__1KXLK","disabled":"Card_disabled__11A2D"};